import * as FIELD_NAME from 'constant/form-item-names'
import * as NUMBER from 'constant/number'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Checkbox, Select } from 'antd'
import _ from 'lodash'

const { Option } = Select

const ArticleSpecialGroupSelect = ({ categories, sites }) => {
  const handleSpecialUpdate = (prevValues, currentValues) => prevValues.category_uuid !== currentValues.category_uuid
  const handleUpdate = (prevValues, currentValues) => prevValues.category_uuid !== currentValues.category_uuid || prevValues.special !== currentValues.special
  return (
    <>
      <Form.Item
        noStyle
        shouldUpdate={handleSpecialUpdate}
      >
        {({ getFieldValue, setFieldsValue }) => {
          const categoryUuids = getFieldValue(FIELD_NAME.CATEGORY_UUID)
          if (!categoryUuids?.length) {
            return
          }

          const subCategories = getSubCats(categories)
          const chosenCategories = categoryUuids.map((chosenUuid) => {
            return subCategories.find(({ uuid }) => uuid === chosenUuid)
          })
          const compactedCategories = _.compact(chosenCategories)
          if (_.isEmpty(compactedCategories)) {
            return
          }
          const groups = getGroups(compactedCategories, sites)
          return groups?.length
          ? (
            <>
              <Form.Item
                name={FIELD_NAME.SPECIAL}
                valuePropName='checked'
              >
                <Checkbox >Permitted Groups</Checkbox>
              </Form.Item>
            </>
          )
          : null
        }}
      </Form.Item>
      {groupSelect(handleUpdate, categories, sites)}
    </>
  )
}

const groupSelect = (handleUpdate, categories, sites) => (
  <Form.Item
    noStyle
    shouldUpdate={handleUpdate}
  >
    {({ getFieldValue }) => {
      const categoryUuids = getFieldValue(FIELD_NAME.CATEGORY_UUID)
      const special = getFieldValue(FIELD_NAME.SPECIAL)
      if (!categoryUuids?.length) {
        return
      }
      const subCategories = getSubCats(categories)
      const chosenCategories = categoryUuids.map((chosenUuid) => {
        return subCategories.find(({ uuid }) => uuid === chosenUuid)
      })
      const compactedCategories = _.compact(chosenCategories)
      if (_.isEmpty(compactedCategories)) {
        return
      }
      const groups = getGroups(compactedCategories, sites)

      return groups?.length && special
            ? (
              getGroupSelect(_.uniqBy(groups, 'user_type_uuid'))
               )
              : null
    }}
  </Form.Item>
)

const getGroups = (chosenCategories, sites) => chosenCategories
  .reduce((result, category) => {
    const site = sites.find(({ uuid }) => uuid === category.site_uuid)
    return (site.special
    ? [
      ...result,
      ...site.special_group
    ]
    : [...result])
  }, [])

const getGroupSelect = (groups) => (<>
  <Form.Item
    name={FIELD_NAME.USER_TYPE_UUIDS}
  >
    <Select
      bordered={false}
      defaultOpen={false}
      dropdownStyle={{ position: 'relative' }}
      getPopupContainer={trigger => trigger.parentNode}
      mode='multiple'
      placeholder={'Permitted Groups'}
      showSearch={false}
      size='large'
      style={{ background: '#fff' }}
    >
      {groups.map(({ name, user_type_uuid: uuid }) => (
        <Option
          key={uuid}
          value={uuid}
        >
          {_.startCase(name)}
        </Option>
      ))}
    </Select>
  </Form.Item>
</>)
const getSubCats = (categories) =>
  categories.map((category) => category.sub_categories.length === NUMBER.ZERO ? [category] : category.sub_categories)
    .flat(NUMBER.TWO)

ArticleSpecialGroupSelect.propTypes = {
  categories: PropTypes.array,
  sites: PropTypes.array
}

const mapStateToProps = (state) => ({
  categories: state.category.categories,
  sites: state.site.allSites
})
export default connect(mapStateToProps)(ArticleSpecialGroupSelect)
